import React, { useState } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { ASSETS } from '../lib/content';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/courses', label: 'The Paths' },
  { to: '/retreats', label: 'Workshops & Retreats' },
  { to: '/facilitators', label: 'Facilitators' },
  { to: '/therapy', label: 'One-to-One' },
  { to: '/investment', label: 'Your Journey' },
  { to: '/booking', label: 'Booking' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  // Close menu on route change
  React.useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-brand-bg/85 border-b border-brand-brown/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 group">
          <img
            src={ASSETS.logo}
            alt="Nurture the Self logo"
            className="h-12 w-12 rounded-full object-cover logo-blend transition-transform duration-700 group-hover:scale-105"
          />
          <div className="leading-tight">
            <div className="font-serif text-xl text-brand-brown tracking-tight">Nurture the Self</div>
            <div className="font-sans text-[11px] uppercase tracking-[0.22em] text-brand-brown-muted">a therapeutic pathway</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === '/'}
              data-testid={`nav-${n.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              className={({ isActive }) =>
                `font-sans text-sm tracking-wide transition-colors duration-300 ${
                  isActive ? 'text-brand-brown underline-gold' : 'text-brand-brown-light hover:text-brand-brown'
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Open menu"
          className="lg:hidden p-2 text-brand-brown"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-brand-brown/5 bg-brand-bg/95 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === '/'}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
                className={({ isActive }) =>
                  `font-sans text-base ${isActive ? 'text-brand-brown' : 'text-brand-brown-light'}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
